module.exports = __webpack_public_path__ + "img/management-share-4.518a939d.png";